import $ from 'jquery'
import {Message} from 'element-ui'
import store from '@/store'

export function mobDataValidate(date) { return _mobDataValidate(date) }
function _mobDataValidate(data) {
    let tmpList = []
    let flag = true
    data.forEach((obj, index) => {
        // ['knowledge', 'alive', 'activity', 'imagead', 'categorynav', 'star', 'searchbar', 'coupon']
        switch (obj.comtype) {
        case 'knowledge':
            if (obj.isdisplaytitle && !obj.titlename) {
                Message.error('标题名称不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 2 && !obj.datalist.length) {
                Message.error('商品不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 3 && !obj.taginnerid) {
                Message.error('商品分组不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        case 'alive':
            if (obj.isdisplaytitle && !obj.titlename) {
                Message.error('标题名称不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 2 && !obj.datalist.length) {
                Message.error('商品不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        case 'activity':
            if (obj.isdisplaytitle && !obj.titlename) {
                Message.error('标题名称不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 2 && !obj.datalist.length) {
                Message.error('商品不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        case 'imagead':
            obj.datalist.forEach((obj2, index2) => {
                if (!obj2.banner.furl) {
                    Message.error(`图文广告第${index2 + 1}个图片不能为空`)
                    store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                    flag = false
                }
                // if (!obj2.objectname) {
                //     Message.error(`图文广告第${index2 + 1}个标题不能为空`)
                //     store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                //     flag = false
                // } else if (!obj2.banner.furl) {
                //     Message.error(`图文广告第${index2 + 1}个图片不能为空`)
                //     store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                //     flag = false
                // } else if (!obj2.urltype) {
                //     Message.error(`图文广告第${index2 + 1}个链接类型不能为空`)
                //     store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                //     flag = false
                // } else if (([1, 2, 5, 7]).indexOf(obj2.urltype) > -1 && !obj2.tourl) {
                //     Message.error(`图文广告第${index2 + 1}个链接不能为空`)
                //     store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                //     flag = false
                // }
            })
            break
        case 'categorynav':
            obj.datalist.forEach((obj2, index2) => {
                if (flag) {
                    if (!obj2.objectname) {
                        console.log(index2)
                        Message.error(`图文导航第${index2 + 1}个标题不能为空`)
                        store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                        flag = false
                    } else if (!obj2.banner.furl) {
                        Message.error(`图文导航第${index2 + 1}个图片不能为空`)
                        store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                        flag = false
                    } else if (!obj2.urltype) {
                        Message.error(`图文导航第${index2 + 1}个链接类型不能为空`)
                        store.commit('图文导航第', {index: index, name: obj.comtype})
                        flag = false
                    } else if (([1, 2, 5, 7]).indexOf(obj2.urltype) > -1 && !obj2.tourl) {
                        Message.error(`图文导航第${index2 + 1}个链接不能为空`)
                        store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                        flag = false
                    }
                }
            })
            break
        case 'star':
            if (obj.isdisplaytitle && !obj.titlename) {
                Message.error('标题名称不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 2 && !obj.datalist.length) {
                Message.error('商品不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        case 'coupon':
            if (obj.datasource === 2 && !obj.datalist.length) {
                Message.error('优惠券不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if (obj.datasource === 1 && !obj.datacount) {
                Message.error('优惠券显示个数不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        case 'starsubject':
            if (obj.datasource === 3 && !obj.datalist.length) {
                Message.error('帖子/资料不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            } else if ((obj.datasource === 1 || obj.datasource === 4) && !obj.datacount) {
                Message.error('帖子/资料显示个数不能为空')
                store.commit('SET_SELECTCOM', {index: index, name: obj.comtype})
                flag = false
            }
            break
        }
        if (flag) {
            let tmpObj = $.extend(true, {}, obj)
            if (tmpObj.datasource === 3) {
                let contentinnerid = tmpObj.datalist[0].contentinnerid ? tmpObj.datalist[0].contentinnerid : ''
                tmpObj.datalist = [{contentinnerid: contentinnerid}]
            }
            tmpObj.isdisplayall = tmpObj.isdisplayall ? 1 : 0
            tmpList.push(tmpObj)
        } else {
            return flag
        }
    })
    return [flag, tmpList]
}
